import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit } from '@angular/core';

@Component({
    selector: 'nav-bar',
    templateUrl: 'nav-bar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class NavBarComponent implements OnInit{
    @Input('links')
    public links: Array<any>;

    @Input('visible')
    public visible: boolean;

    @Input()
    activeLink: string;

    @Output()
    public click: EventEmitter<any> = new EventEmitter<Event>();;

    @Output()
    public toggleNavBarClick: EventEmitter<any> = new EventEmitter<Event>();;

    ngOnInit(){
        this.links = this.links || [];
        this.visible = this.visible || false;
    }

    public onClick(event: Event, route?: string) {
        event.preventDefault();
        event.stopPropagation();

        this.click.emit({ event, route });
    }

    public onToggleNavBarClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.toggleNavBarClick.emit({ event });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/nav-bar.component.ts